import { Data } from '@blade/std-lib'

export class WrongCredentialsError extends Data.TaggedError(
  'WrongCredentialsError',
) {}

export class OtpRequiredError extends Data.TaggedError('OtpRequiredError') {}

export class WrongOtpError extends Data.TaggedError('WrongOtpError') {}

export class OtpAttemptsExceededError extends Data.TaggedError(
  'OtpAttemptsExceededError',
) {}

export class UserNotFoundError extends Data.TaggedError('UserNotFoundError') {}
